var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2127_58086)",
    fill: "transparent"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7187 26.9062H3.28125C2.07309 26.9062 1.09375 25.9269 1.09375 24.7188V3.28125C1.09375 2.07315 2.07309 1.09375 3.28125 1.09375H24.7187C25.9269 1.09375 26.9062 2.07315 26.9062 3.28125V24.7188C26.9062 25.9269 25.9269 26.9062 24.7187 26.9062Z",
    stroke: "#00B956",
    strokeWidth: 2.1875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25781 21.9297L8.98056 14.2069C9.83484 13.3527 11.2199 13.3527 12.0741 14.2069L16.2422 18.375L18.2227 16.3944C19.077 15.5402 20.462 15.5402 21.3163 16.3944L26.6602 21.7383",
    stroke: "#00B956",
    strokeWidth: 2.1875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5312 7.65625C15.5312 8.86435 16.5106 9.84375 17.7188 9.84375C18.9269 9.84375 19.9062 8.86435 19.9062 7.65625C19.9062 6.44815 18.9269 5.46875 17.7188 5.46875C16.5106 5.46875 15.5312 6.44815 15.5312 7.65625Z",
    stroke: "#00B956",
    strokeWidth: 2.1875,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2127_58086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGallery);
export default __webpack_public_path__ + "static/media/icon-gallery.8a09f214d367a6058ecbfabb89c4110e.svg";
export { ForwardRef as ReactComponent };